<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="险种类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['insuranceType', validatorRules.insuranceType]"
                                   :trigger-change="true" dictCode="bms_insurance_type" placeholder="请输入险种类型">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="险种名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['insuranceName', validatorRules.insuranceName]" placeholder="请输入险种名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remarks', {}]"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: 'BizInsuranceWithTypeForm', // 保险人发票信息配置
    components: {
      JFormContainer,
      JDictSelectTag
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          insuranceType: {
            rules: [
              { required: true, message: '请选择险种类型' },
            ]
          },
          insuranceName: {
            rules: [
              { required: true, message: '请输入险种名称' },
            ]
          }
        },
        url: {
          add: "/biz/insuranceWithType/add",
          edit: "/biz/insuranceWithType/edit",
          checkExist:"/biz/insuranceWithType/checkExistByInsuranceName",
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'insuranceType','insuranceName',"remarks"))
        })
      },

      async submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            that.trimFormData(formData)

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },

      trimFormData(formData){
        //formData.insuranceType = formData.insuranceType ? formData.insuranceType.trim() : '';
        formData.insuranceName = formData.insuranceName ? formData.insuranceName.trim() : '';
        formData.remarks = formData.remarks ? formData.remarks.trim() : '';
      },

      async checkExistByInsuranceName(name){
        if(name === undefined || name === null || name.trim() === ""){
            return true
        }
        await httpAction(this.url.checkExist,{insuranceName: name.trim()},"POST").then((res)=>{
          if(res.success){
            if(res.result){
              return true
            } else {
              return false
            }
          }else{ // 发生异常，认为存在，不能继续保存
            this.$message.warning(res.message);
            return true
          }
        })
      },

      popupCallback(row){
        this.form.setFieldsValue(pick(row,'insuranceType','insuranceName',"remarks"))
      },
    }
  }
</script>